<template>
  <v-overlay class="mit-edit-user" :dark="false" opacity=".8" z-index="1000" :value="show">
    <v-container class="pa-30">
      <v-row>
        <v-col cols="12" class="d-flex justify-left">
          <v-card v-if="editUser" class="card" min-width="600" max-width="600" >
            <v-text-field v-model="editUser.csailId" label="CSAIL ID" placeholder="Placeholder" outlined></v-text-field>
            <v-text-field v-model="editUser.csailEmail" label="Email" placeholder="Placeholder" outlined></v-text-field>
            <v-combobox label="Role" @change="roleChanged" :items="roles" item-text="name" item-value="id" v-model="selectedRole" dense filled outlined solo></v-combobox>
            <v-text-field v-model="editUser.fname" label="First Name" placeholder="Placeholder" outlined></v-text-field>
            <v-text-field v-model="editUser.lname" label="Last Name" placeholder="Placeholder" outlined></v-text-field>
            <v-text-field v-model="editUser.groups" label="Groups" placeholder="Placeholder" outlined></v-text-field>
            <!-- <v-textarea outlined label="Role Overrides" v-model="user.role_overrides"></v-textarea> -->
            <v-btn color="success" @click="save()">Save</v-btn>
            <v-btn class="ml-5" @click="$emit('cancel')">Cancel</v-btn>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-overlay>
</template>

<script>

export default {
  name: 'MitEditUser',
  components: {},
  props: {
    show: Boolean,
    editUser: Object
  },
  watch: {
    editUser: function (val) {
      //Load the new selected role.
      for(let x = 0; x < this.roles.length; x++){
        if(this.roles[x].id == val.role){
          this.selectedRole = this.roles[x];
          break;
        }
      }
    }
  },
  data: function() {
    return {
      selectedRole:{
          name: 'USER',
          id: 10
      },
      roles:[ {
            name: 'DISABLED',
            id: 0
        },
        {
            name: 'USER',
            id: 10
        },
        {
            name: 'MANAGER',
            id: 20
        },
        {
            name: 'ADMIN',
            id: 30
        }
      ]
    }
  },
  methods: {
    roleChanged (item){
      //Save the new role into the user object
      this.editUser.role = item.id;
    },
    save (){
      this.$emit('save');
    }
  }

}
</script>

<style lang="scss" scoped>
  .card {
    padding: 30px;
  }
</style>
